module.exports = {
  SCREEN_OVERFLOW_BUFFER: 1000,
  ROW_HEIGHT: 27
};